import React, { useMemo } from "react";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";

import TableWidget from "../../../../components/tables/TableWidget";

import CollectionErrorsDropdwonsHeader from "./components/CollectionErrorsDropdwonsHeader";
import { TableActions } from "../../../../components/tables/tableContext/TableContext";
import {
  collectionErrorsSimplifiedTableHeader,
  getCollectionErrorsSimplifiedTableData,
} from "./tableConfigs/collectionErrorsTableConfig";
import { postCollectionErrorsSimplified } from "../../../../redux/api/reports.api";

const SimplifiedHeader = () => (
  <CollectionErrorsDropdwonsHeader reportType="simplified" />
);

function CollectionErrorsSimplified() {
  const dispatch = useAppDispatch();

  const {
    reports: {
      collectionErrorsSimplifed: {
        data: { data: collectionErrorsSimplified, total },
        isLoading,
      },
    },
  } = useAppSelector((state) => ({
    reports: state.reports,
  }));

  const tableItems = useMemo(
    () => getCollectionErrorsSimplifiedTableData(collectionErrorsSimplified),
    [collectionErrorsSimplified],
  );

  const handleTableActions = (action: TableActions) => {
    if (
      action.tablePagination.page &&
      action.tablePagination.rowsPerPage &&
      action.tableSearch
    ) {
      if (
        action.tableSearch.selectedMonth &&
        action.tableSearch.selectedYear &&
        action.tableSearch.selectedUsers
      ) {
        dispatch(
          postCollectionErrorsSimplified({
            page: action.tablePagination.page,
            per_page: action.tablePagination.rowsPerPage,
            selectedUsers: JSON.parse(action.tableSearch.selectedUsers),
            month: action.tableSearch.selectedMonth,
            year: action.tableSearch.selectedYear,
            day: parseInt(action.tableSearch.selectedDay),
          }),
        );
      }
    }
  };

  return (
    <TableWidget
      tableHeaderData={collectionErrorsSimplifiedTableHeader}
      tableItemsData={tableItems}
      handleTableActions={handleTableActions}
      CustomHeaderComponent={SimplifiedHeader}
      totalItems={total}
      tableLoading={isLoading}
      withGlobalSearch={false}
      withGlobalFilter={false}
    />
  );
}

export default CollectionErrorsSimplified;
